import { createWebHistory, createRouter } from "vue-router";
import Index from "../pages/index-startup.vue";
import authenticationMixin from "@/mixins/authenticationMixin";
import { useAuthStore } from "@/stores/store";

// navigation guard for routes
async function requireAuth(to, from, next) {
  if (await authenticationMixin.methods.handleTokenValidationAndRenewal(false)) {
    return next();
  } else {
    //sign out the user and redirect to login page
    const authStore = useAuthStore();

    //save the destination route
    await authStore.saveToRouteAfterAuthentication(to.name);
    await authStore.signOut();
    return next({ name: "AuthLogin" });
  }
}


const routes = [
  {
    path: "/",
    name: "Index",
    component: Index,
  },
  {
    path: "/homeTour",
    name: "HomeTour",
    component: () => import("@/pages/HomeTour.vue"),
  },
  {
    path: "/property-listings",
    name: "propertyListings",
    component: () => import("@/pages/PropertyListings.vue"),
  },
  {
    path: "/cda",
    name: "CdaForm",
    component: () => import("@/pages/cda.vue"),
    beforeEnter:requireAuth,
  },
  {
    path: "/auth-login",
    name: "AuthLogin",
    component: () => import("@/pages/auth-login.vue"),
  },
  {
    path: "/auth-signup",
    name: "AuthSignup",
    component: () => import("@/pages/auth-signup.vue"),
  },
  {
    path: "/auth-reset-password",
    name: "AuthResetPass",
    component: () => import("@/pages/auth-reset-password.vue"),
  },
  {
    path: "/our-team",
    name: "OurAgents",
    component: () => import("@/components/Team/OurAgents.vue"),
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    component: () => import("@/pages/maintenance.vue"),
  },
  {
    path: "/get-started",
    name: "GetStarted",
    component: () => import("@/pages/get-started.vue"),
  },
  {
    path: "/contact-page",
    name: "ContactPage",
    component: () => import("@/pages/ContactPage.vue"),
  },
  {
    path: "/error-page",
    name: "Error",
    component: () => import("@/pages/error.vue"),
  },
  {
    path: "/:catchAll(.*)",
    name: "Index",
    component: () => import('@/pages/index-startup.vue'),
  },
];


const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: function (to, _from, savedPosition) {
    if (savedPosition) {
        return savedPosition;
    }
    if (to.hash) {
        return { el: to.hash, behavior: 'smooth' };
    } else {
    setTimeout(() => {
        window.scrollTo(0, 0);
    }, 5);
    }
},
});

export default router;